import { render } from "./GetPlainDialog.vue?vue&type=template&id=66df982e&scoped=true"
import script from "./GetPlainDialog.vue?vue&type=script&lang=js"
export * from "./GetPlainDialog.vue?vue&type=script&lang=js"

import "./GetPlainDialog.vue?vue&type=style&index=0&id=66df982e&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66df982e"]])

export default __exports__